import { addAndTrack, simpleAnTmaker } from "../../../calculators/helpers";
import { NAs } from "../../../configs";
import { Green, Hydro, hydroDmg } from "../../../styledCpns/DataDisplay";
import { mediumPAs } from "../config";
import { checkAscs, checkCons, makeTlBnes, xtraTlLv } from "../helpers";

const Candace = {
  code: 58,
  name: "Candace",
  icon: "d/dd/Candace_Icon",
  sideIcon: "9/95/Character_Candace_Side_Icon",
  rarity: 4,
  nation: "Sumeru",
  vision: "Hydro",
  weapon: "Polearm",
  stats: [
    { "Base HP": 912, "Base ATK": 18, "Base DEF": 57 },
    { "Base HP": 2342, "Base ATK": 46, "Base DEF": 147 },
    { "Base HP": 3024, "Base ATK": 59, "Base DEF": 190 },
    { "Base HP": 4529, "Base ATK": 88, "Base DEF": 284 },
    { "Base HP": 5013, "Base ATK": 98, "Base DEF": 315, "HP%": 6 },
    { "Base HP": 5766, "Base ATK": 113, "Base DEF": 362, "HP%": 6 },
    { "Base HP": 6411, "Base ATK": 125, "Base DEF": 402, "HP%": 12 },
    { "Base HP": 7164, "Base ATK": 140, "Base DEF": 450, "HP%": 12 },
    { "Base HP": 7648, "Base ATK": 149, "Base DEF": 480, "HP%": 12 },
    { "Base HP": 8401, "Base ATK": 164, "Base DEF": 527, "HP%": 12 },
    { "Base HP": 8885, "Base ATK": 174, "Base DEF": 558, "HP%": 18 },
    { "Base HP": 9638, "Base ATK": 188, "Base DEF": 605, "HP%": 18 },
    { "Base HP": 10122, "Base ATK": 198, "Base DEF": 635, "HP%": 24 },
    { "Base HP": 10875, "Base ATK": 212, "Base DEF": 683, "HP%": 24 }
  ],
  actvTalents: [
    {
      type: "Normal Attack",
      name: "Gleaming Spear - Guardian Stance",
      desc: [],
      stats: [
        {
          name: "1-Hit",
          dmgTypes: ["NA", "Physical"],
          baseMult: 60.8,
          multType: 1
        },
        {
          name: "2-Hit",
          dmgTypes: ["NA", "Physical"],
          baseMult: 61.15,
          multType: 1
        },
        {
          name: "3-Hit",
          dmgTypes: ["NA", "Physical"],
          baseMult: [35.49, 43.37],
          multType: 1
        },
        {
          name: "4-Hit",
          dmgTypes: ["NA", "Physical"],
          baseMult: 94.94,
          multType: 1
        },
        {
          name: "Charged Attack DMG",
          dmgTypes: ["CA", "Physical"],
          baseMult: 124.18,
          multType: 1
        },
        ...mediumPAs
      ]
    },
    {
      type: "Elemental Skill",
      name: "Sacred Rite: Heron's Sanctum",
      image: "5/5d/Talent_Sacred_Rite_Heron%27s_Sanctum",
      desc: [],
      getXtraLv: xtraTlLv.cons5,
      stats: [
        {
          name: "Shield DMG Absorption",
          baseSType: "HP",
          baseMult: 12,
          multType: 2,
          baseFlat: 1156,
          flatType: 3
        },
        {
          name: "Basic DMG",
          dmgTypes: ["ES", "Elemental"],
          baseSType: "HP",
          baseMult: 12.43,
          multType: 2
        },
        {
          name: "Charged Up DMG",
          dmgTypes: ["ES", "Elemental"],
          baseSType: "HP",
          baseMult: 20.43,
          multType: 2
        }
      ]
    },
    {
      type: "Elemental Burst",
      name: "Sacred Rite: Wagtail's Tide",
      image: "1/1a/Talent_Sacred_Rite_Wagtail%27s_Tide",
      desc: [],
      getXtraLv: xtraTlLv.cons3,
      stats: [
        {
          name: "Skill DMG",
          dmgTypes: ["EB", "Elemental"],
          baseSType: "HP",
          baseMult: 6.61,
          multType: 2
        },
        {
          name: "Wave Impact DMG",
          dmgTypes: ["EB", "Elemental"],
          baseSType: "HP",
          baseMult: 6.61,
          multType: 2
        },
        {
          name: "Wave DMG (C6)",
          dmgTypes: ["EB", "Elemental"],
          baseSType: "HP",
          baseMult: 0,
          multType: 2,
          getTlBnes: ({ char }) =>
            makeTlBnes(checkCons[6](char), "mult", [0, 6], 15)
        }
      ],
      otherStats: (lv) => [
        {
          name: "Wave Instances",
          value: 3
        },
        { name: "Duration", value: "9s" },
        { name: "CD", value: "15s" }
      ],
      energyCost: 60
    }
  ],
  pasvTalents: [
    {
      type: "Ascension 1",
      name: "Aegis of Crossed Arrows",
      image: "3/33/Talent_Aegis_of_Crossed_Arrows",
      desc: (
        <>
          If Candace is hit by an attack in the Hold duration of Sacred Rite:
          Heron's Sanctum, that skill will finish charging instantly.
        </>
      )
    },
    {
      type: "Ascension 4",
      name: "Celestial Dome of Sand",
      image: "8/86/Talent_Celestial_Dome_of_Sand",
      desc: (
        <>
          Characters affected by the Prayer of the Crimson Crown caused by
          Sacred Rite: Wagtail's Tide will deal <Green b>0.5%</Green>{" "}
          <Green>increased DMG</Green> to opponents for every 1,000 points of
          Candace's Max HP when they deal Elemental DMG with their Normal
          Attacks.
        </>
      )
    },
    {
      type: "Passive",
      name: "To Dawn's First Light",
      image: "a/a6/Talent_To_Dawn%27s_First_Light",
      desc: <></>
    }
  ],
  constellation: [
    {
      name: "Returning Heir of the Scarlet Sands",
      image: "1/1d/Constellation_Returning_Heiress_of_the_Scarlet_Sands",
      desc: (
        <>
          The <Green>duration</Green> of Prayer of the Crimson Crown effect
          triggered by Sacred Rite: Wagtail's Tide is increased by{" "}
          <Green b>3s</Green>.
        </>
      )
    },
    {
      name: "Moon-Piercing Brilliance",
      image: "3/3b/Constellation_Moon-Piercing_Brilliance",
      desc: (
        <>
          When Sacred Rite: Heron's Guard hits opponents, Candace's{" "}
          <Green>Max HP</Green> will be increased by <Green>20%</Green> for 15s.
        </>
      )
    },
    {
      name: "Hunter's Supplication",
      image: "f/f2/Constellation_Hunter%27s_Supplication",
      desc: "Sacred Rite: Wagtail's Tide"
    },
    {
      name: "Sentinel Oath",
      image: "b/b7/Constellation_Sentinel_Oath",
      desc: (
        <>
          Shortens the Hold CD of Sacred Rite: Heron's Guard to be the same as
          that of the Tapping CD.
        </>
      )
    },
    {
      name: "Golden Eye",
      image: "f/fc/Constellation_Heterochromatic_Gaze",
      desc: "Sacred Rite: Heron's Guard"
    },
    {
      name: "The Overflow",
      image: "e/ec/Constellation_The_Overflow",
      desc: (
        <>
          When characters (excluding Candace herself) affected by the Prayer of
          the Crimson Crown caused by Sacred Rite: Wagtail's Tide deal Elemental
          DMG to opponents using normal Attacks, an attack wave will be
          unleashed that deals AoE {hydroDmg} equal to <Green b>15%</Green> of
          Candace’s <Green>Max HP</Green>.
          <br />
          This effect can trigger once every 2.3s and is considered Elemental
          Burst DMG.
        </>
      )
    }
  ],
  buffs: [
    {
      index: 0,
      src: "Elemental Burst",
      desc: () => (
        <>
          Prayer of the Crimson Crown has the following properties:
          <br />• Characters deal <Green b>20%</Green> increased Elemental DMG
          with their <Green>Normal Attacks</Green>.
          <br />• Active Sword, Claymore, and Polearm-wielding character(s)
          under this effect will obtain a <Hydro>Hydro Infusion</Hydro>.
        </>
      ),
      isGranted: () => true,
      affect: "party",
      addBnes: ({ charData, hitBnes, infusion, tkDesc, tracker }) => {
        if (charData.weapon === "Catalyst" || infusion.NA !== "Physical") {
          addAndTrack(tkDesc, hitBnes, "NA.pct", 20, tracker);
        }
      },
      canInfuse: ({ weapon }) =>
        ["Sword", "Claymore", "Polearm"].includes(weapon),
      infuseElmt: "Hydro",
      infuseRange: NAs,
      canBeOverrided: true
    },
    {
      index: 1,
      src: "Ascension 4 Passive Talent",
      desc: () => Candace.pasvTalents[1].desc,
      isGranted: checkAscs[4],
      affect: "party",
      labels: ["Max HP"],
      inputs: [0],
      inputTypes: ["text"],
      maxs: [99999],
      addFinalBnes: ({ toSelf, ATTRs, hitBnes, inputs, tkDesc, tracker }) => {
        const maxHP = toSelf ? ATTRs.HP : inputs[0];
        const bnValue = (maxHP / 1000) * 0.5;
        addAndTrack(tkDesc, hitBnes, "NA.pct", bnValue, tracker);
      }
    },
    {
      index: 2,
      src: "Constellation 2",
      desc: () => Candace.constellation[1].desc,
      isGranted: checkCons[2],
      affect: "self",
      addBnes: simpleAnTmaker("ATTRs", "HP%", 20)
    }
  ]
};

export default Candace;
